import React from "react"
import PropTypes from "prop-types"

const BulkBar = ({ selected, bulk, onChange, onAplicar, onLimpiar }) => (
  <div className="cfg-bulk">
    <span className="cfg-bulk-label">
      {selected.length}
      {selected.length === 1
        ? " cliente seleccionado"
        : " clientes seleccionados"}
    </span>

    <div className="cfg-bulk-sep" />

    <div className="cfg-bulk-group">
      <span>Horario</span>
      <input
        type="time"
        className="cfg-bulk-input"
        value={bulk.inicio}
        onChange={event => onChange("inicio", event.target.value)}
      />
      <span>a</span>
      <input
        type="time"
        className="cfg-bulk-input"
        value={bulk.fin}
        onChange={event => onChange("fin", event.target.value)}
      />
    </div>

    <div className="cfg-bulk-group">
      <span>Comisión $</span>
      <input
        type="number"
        min="0"
        step="0.1"
        placeholder="—"
        className="cfg-bulk-input cfg-bulk-fee"
        value={bulk.comision}
        onChange={event => onChange("comision", event.target.value)}
      />
    </div>

    <button type="button" className="cfg-btn-apply" onClick={onAplicar}>
      Aplicar a seleccionados
    </button>
    <button type="button" className="cfg-btn-link" onClick={onLimpiar}>
      Limpiar
    </button>
  </div>
)

BulkBar.propTypes = {
  selected: PropTypes.array.isRequired,
  bulk: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onAplicar: PropTypes.func.isRequired,
  onLimpiar: PropTypes.func.isRequired,
}

export default BulkBar
